import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import Slide from '@mui/material/Slide';

const buttonStyle = {
    background: 'linear-gradient(to right, #0d7ae3 50%, white 50%)',
    backgroundSize: '200% 100%',
    backgroundPosition: '0% 50%',
    transition: 'background-position 1s',
    '&:hover': {
        backgroundPosition: '100% 50%',
        color: '#0d7ae3', 
    },
    color: 'white', 
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProfileUpdate({ openProfile, handleClose }) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [passwordUi, setPasswordUi] = useState('');

    const handleUi = (condition) => {
        setPasswordUi(condition);
    };

    return (
        <React.Fragment>
            <Dialog
                TransitionComponent={Transition}
                open={openProfile}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        minWidth: isMobile ? '90vw' : '35vw',
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                    {"Update Profile"}
                </DialogTitle>
                <DialogContent>
                    {passwordUi === 'forgot' ? (
                        <>
                            <Grid container direction='column' spacing={2}>
                                <Grid item md={12}>
                                    <TextField id="mobile" label="Mobile" variant="outlined" fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Grid container direction="row">
                                        <Grid item xs={6} sm={6} md={6}>
                                            <TextField id="otp" label="OTP" variant="outlined" fullWidth size='small' />
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                            <Button sx={{ marginLeft: '20px' }} variant='contained'>Verify</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={12}>
                                    <Button sx={buttonStyle} variant='contained' size="large" fullWidth >Submit</Button>
                                </Grid>
                            </Grid>
                        </>
                    ) : passwordUi === 'update' ? (
                        <>
                            <Grid container direction='column' spacing={2}>
                                <Grid item md={12}>
                                    <TextField id="old-password" label="Old Password" variant="outlined" fullWidth />
                                </Grid>
                                <Grid item md={12}>
                                    <TextField id="new-password" label="New Password" variant="outlined" fullWidth />
                                </Grid>
                                <Grid item md={12}>
                                    <Typography variant='subtitle2' sx={{ color: '#0d7ae3' }} onClick={(e) => { handleUi('forgot') }}>Forgot Password?</Typography>
                                </Grid>
                                <Grid item md={12}>
                                    <Button sx={buttonStyle} variant='contained' size="large" fullWidth >Submit</Button>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid container direction='column' spacing={2}>
                                <Grid item md={12}>
                                    <TextField id="name" label="Name" variant="outlined" fullWidth />
                                </Grid>
                                <Grid item md={12}>
                                    <TextField id="email" label="Email" variant="outlined" fullWidth />
                                </Grid>
                                <Grid item md={12}>
                                    <TextField id="phone" label="Phone" variant="outlined" fullWidth disabled={true} />
                                </Grid>
                                <Grid item md={12}>
                                    <Grid container justifyContent='space-between'>
                                        <Grid item>
                                            <Button sx={buttonStyle} variant='contained' size="large" fullWidth onClick={(e) => { handleUi('update') }}>Update Password</Button>
                                        </Grid>
                                        <Grid item>
                                            <Button sx={buttonStyle} variant='contained' size="large" fullWidth onClick={(e) => { handleUi('forgot') }}>Forgot password</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={12}>
                                    <Button sx={buttonStyle} variant='contained' size="large" fullWidth >Submit</Button>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
